<script>

export default {
    name: 'CpSocialFeedCompleteProfile',
    components: {
        CpBaseSvgIcon: require('../../base-svg-icon').default,
        CpButtonLink: require('../../button-link').default,
        CpGrid: require('../../grid').default,
        CpGridItem: require('../../grid-item').default,
        CircleCheckIcon: require('../icons/circle-check').default,
    },
    directives: {
        marginTop: require('../../directives/margins').marginTop,
        marginLeft: require('../../directives/margins').marginLeft,
    },
    props: {
        user: Object,
    },
    data() {
        return {
            checkIconWidth: 30,
            checkIconHeight: 30,
            checkIconViewBox: '0 0 32 32',
            successColor: '#00A171',
            uncompleteColor: '#808080',
        }
    },
};
</script>

<template>

    <div class="container">
        <h3 class="buttons neutral5-color textCenter">Complete your profile</h3>
        <p class="footnote neutral5-color textCenter">Complete your profile now and customize your CrowdBlue experience.
        </p>
        <ol>
            <div>
                <cp-base-svg-icon class="svg-icon" :width="checkIconWidth" :height="checkIconHeight" :viewBox="checkIconViewBox">
                    <circle-check-icon :icon-color="user.email_verified ? successColor : uncompleteColor"
                        :stroke-color="user.email_verified ? successColor : uncompleteColor" />
                </cp-base-svg-icon>
                <li v-margin-left="1" class="caption1 neutral4-color">Verify your email.</li>
            </div>
            <div>
                <cp-base-svg-icon class="svg-icon" :width="checkIconWidth" :height="checkIconHeight" :viewBox="checkIconViewBox">
                    <circle-check-icon :icon-color="user.image ? successColor : uncompleteColor"
                        :stroke-color="user.image ? successColor : uncompleteColor" />
                </cp-base-svg-icon>
                <li v-margin-left="1" class="caption1 neutral4-color">Upload a profile picture.</li>
            </div>
            <div>
                <cp-base-svg-icon class="svg-icon" :width="checkIconWidth" :height="checkIconHeight" :viewBox="checkIconViewBox">
                    <circle-check-icon :icon-color="user.political_party ? successColor : uncompleteColor"
                        :stroke-color="user.political_party ? successColor : uncompleteColor" />
                </cp-base-svg-icon>
                <li v-margin-left="1" class="caption1 neutral4-color">Select your political party.</li>
            </div>
            <div>
                <cp-base-svg-icon class="svg-icon" :width="checkIconWidth" :height="checkIconHeight" :viewBox="checkIconViewBox">
                    <circle-check-icon :icon-color="user.address_state ? successColor : uncompleteColor"
                        :stroke-color="user.address_state ? successColor : uncompleteColor" />
                </cp-base-svg-icon>
                <li v-margin-left="1" class="caption1 neutral4-color">Enter your state.</li>
            </div>
            <div>
                <cp-base-svg-icon class="svg-icon" :width="checkIconWidth" :height="checkIconHeight" :viewBox="checkIconViewBox">
                    <circle-check-icon :icon-color="user.address_zip ? successColor : uncompleteColor"
                        :stroke-color="user.address_zip ? successColor : uncompleteColor" />
                </cp-base-svg-icon>
                <li v-margin-left="1" class="caption1 neutral4-color">Enter your zip code.</li>
            </div>
            <div>
                <cp-base-svg-icon class="svg-icon" :width="checkIconWidth" :height="checkIconHeight" :viewBox="checkIconViewBox">
                    <circle-check-icon :icon-color="user.tags.length ? successColor : uncompleteColor"
                        :stroke-color="user.tags.length ? successColor : uncompleteColor" />
                </cp-base-svg-icon>
                <li v-margin-left="1" class="caption1 neutral4-color">Choose your areas of interest.</li>
            </div>
        </ol>
        <cp-button-link class="textCenter" noborder block href="/user/settings">Complete all</cp-button-link>
    </div>

</template>

<style scoped>
.container {
    padding: 16px 8px;
    border: 1px solid var(--neutral4);
    border-radius: 8px;
    box-shadow: 0px 0px 10px 0px #00000033;
}

.textCenter {
    text-align: center;
}

ol div {
    display: flex;
    align-items: center;
    padding: 4px 0;
}

.svg-icon {
    width: 30px;
    height: 30px;
    flex-shrink: 0;

}
</style>
